import { gql } from '@apollo/client'
import { pick } from 'ramda'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import React from 'react'

import { analyticsClient } from '../../../../../../utils/apollo/api'
import { useGenericState } from '../../../../../../packages/kiti/components/helpers/GenericState'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useNonCompliancesCounterState = () => React.useContext(Context)
export const useNonCompliancesCounter = () => useNonCompliancesCounterState()?.nonCompliancesCounter

const QUERY = gql`
  query NonCompliancesCounter($filter: NonCompliancesCounterFilter) {
    nonCompliancesCounter(filter: $filter) {
      totalCount
      nonCompliancesCount
    }
  }
`

const NonCompliancesCounterLoader = ({ children }) => {
  const filter = useCleanFilterForRequest() || {}
  const { value } = useGenericState()

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: {
        nonComplianceType: value?.nonComplianceType?.id || 'service_order',
        ...pick(['placeIds', 'placeLevelIds', 'userIds', 'checklistIds', 'date'], filter)
      }
    },
    client: analyticsClient
  })

  return (
    <StatePresenter {...state} empty={!data?.nonCompliancesCounter?.totalCount}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default NonCompliancesCounterLoader
